export default __webpack_public_path__ + "static/media/portfolio-92.f3a550cb.jpg";